import type { UseFormReturn } from 'react-hook-form';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ISearchArticlesFormBodyValues } from './SearchArticlesFormBody';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type ISearchArticlesFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<ISearchArticlesFormBodyValues>;
  loading?: boolean;
};

export const SearchArticlesFormMainSection: React.FC<
  ISearchArticlesFormMainSectionProps
> = (props) => {
  const { sx, form, loading } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <FormField
        label={t('SearchArticlesFormMainSection.fields.text.label')}
        name="text"
        control={form.control}
        as={TextInputField}
        forwardError
        variant="outlined"
        required
        clearable
        type="search"
        end={
          <Button
            type="submit"
            loading={loading}
            icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
          >
            {t('common.search')}
          </Button>
        }
      />
    </FormSection>
  );
};
